export class FPSTracker {
    private buffer: Float32Array;
    private index = 0;
    private filled = 0;
    private sum = 0;

    // -- session recording --
    private sessionMinFps = Infinity;
    private sessionMaxFps = 0;
    private sessionFpsSum = 0;
    private sessionSampleCount = 0;

    private isRecording = false;

    constructor(private readonly size = 100) {
        this.buffer = new Float32Array(size);
    }

    public push(deltaMS: number): void {
        this.sum -= this.buffer[this.index];
        this.buffer[this.index] = deltaMS;
        this.sum += deltaMS;

        this.index = (this.index + 1) % this.size;
        if (this.filled < this.size) this.filled++;

        if (!this.isRecording) return;

        const currentAvgFps = this.getAverageFPS();
        this.sessionMinFps = Math.min(this.sessionMinFps, currentAvgFps);
        this.sessionMaxFps = Math.max(this.sessionMaxFps, currentAvgFps);
        this.sessionFpsSum += currentAvgFps;
        this.sessionSampleCount++;
    }

    public getAverageFPS(): number {
        if (this.filled === 0) return 0;
        const avgFrameTimeMs = this.sum / this.filled;
        return 1000 / avgFrameTimeMs;
    }

    public getMinFPS(): number {
        if (this.filled === 0) return 0;
        let maxDt = 0;
        for (let i = 0; i < this.filled; i++) maxDt = Math.max(maxDt, this.buffer[i]);
        return 1000 / maxDt;
    }

    // -- session recording control --

    public startSession(): void {
        this.sessionMinFps = Infinity;
        this.sessionMaxFps = 0;
        this.sessionFpsSum = 0;
        this.sessionSampleCount = 0;
        this.isRecording = true;
    }

    public stopSession(): void {
        this.isRecording = false;
    }

    public isSessionRecording(): boolean {
        return this.isRecording;
    }

    public getSessionMinFPS(): number {
        return this.sessionSampleCount === 0 ? 0 : this.sessionMinFps;
    }

    public getSessionMaxFPS(): number {
        return this.sessionSampleCount === 0 ? 0 : this.sessionMaxFps;
    }

    public getSessionAverageFPS(): number {
        return this.sessionSampleCount === 0 ? 0 : this.sessionFpsSum / this.sessionSampleCount;
    }
}
